import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Loading, Crumbs, ShareMenu } from "@/components/common";
import FlashCard from "@/components/FlashCard";

export default function RelampagoDetail() {
  const { id } = useParams();
  const [poll, setPoll] = useState(null);
  useEffect(() => { api.get(`/flash/${id}`).then((r) => setPoll(r.data)).catch(() => setPoll(false)); }, [id]);

  if (poll === null) return <Loading />;
  if (poll === false) return <div className="max-w-3xl mx-auto px-6 py-20 text-center text-slate-400">Consulta relámpago no encontrada.</div>;

  return (
    <div className="max-w-3xl mx-auto px-6 py-10" data-testid="relampago-detail">
      <Crumbs items={[{ label: "2Voto Relámpago", to: "/relampago" }, { label: poll.title }]} />
      <div className="flex justify-end -mt-2 mb-4"><ShareMenu title={poll.question || poll.title} /></div>
      <FlashCard poll={poll} />
    </div>
  );
}
